import {
  useEffect,
  useState
} from "react";

import {
  FaBoxes,
  FaCubes,
  FaTruck,
  FaUsers,
  FaWarehouse,
  FaIndustry,
  FaFileInvoice
} from "react-icons/fa";

import MainLayout from "../../components/layout/MainLayout";

import {
  getDashboard
} from "../../api/dashboardApi";

import "./Dashboard.css";

const Dashboard = () => {

  const [data, setData] =
    useState({});

  useEffect(() => {

    loadDashboard();

  }, []);

  const loadDashboard =
    async () => {

      try {

        const res =
          await getDashboard();

        setData(
          res.data.data
        );

      }
      catch (error) {

        console.log(error);

      }

    };

  return (

    <MainLayout>

      <div className="dashboard-header">

        <div>

          <h2>
            Dashboard Overview
          </h2>

          <p>
            Monitor inventory, production and dispatch activities.
          </p>

        </div>

      </div>

      {/* Main Statistics */}

      <div className="row g-4 mb-4">

        <div className="col-lg-3 col-md-6">

          <div className="dashboard-card">

            <div>

              <span className="card-title">
                Materials
              </span>

              <h2>
                {data.total_materials || 0}
              </h2>

            </div>

            <FaBoxes className="card-icon" />

          </div>

        </div>

        <div className="col-lg-3 col-md-6">

          <div className="dashboard-card">

            <div>

              <span className="card-title">
                Products
              </span>

              <h2>
                {data.total_products || 0}
              </h2>

            </div>

            <FaCubes className="card-icon" />

          </div>

        </div>

        <div className="col-lg-3 col-md-6">

          <div className="dashboard-card">

            <div>

              <span className="card-title">
                Suppliers
              </span>

              <h2>
                {data.total_suppliers || 0}
              </h2>

            </div>

            <FaTruck className="card-icon" />

          </div>

        </div>

        <div className="col-lg-3 col-md-6">

          <div className="dashboard-card">

            <div>

              <span className="card-title">
                Customers
              </span>

              <h2>
                {data.total_customers || 0}
              </h2>

            </div>

            <FaUsers className="card-icon" />

          </div>

        </div>

      </div>

      {/* Today's Activity */}

      <div className="row g-4 mb-4">

        <div className="col-lg-4">

          <div className="activity-card">

            <FaWarehouse />

            <h4>
              {data.today_grn || 0}
            </h4>

            <p>
              Today's GRN
            </p>

          </div>

        </div>

        <div className="col-lg-4">

          <div className="activity-card">

            <FaIndustry />

            <h4>
              {data.today_production || 0}
            </h4>

            <p>
              Production Orders
            </p>

          </div>

        </div>

        <div className="col-lg-4">

          <div className="activity-card">

            <FaFileInvoice />

            <h4>
              {data.today_dispatch || 0}
            </h4>

            <p>
              Dispatch Orders
            </p>

          </div>

        </div>

      </div>

      {/* Quick Actions */}

      <div className="row g-4">

        <div className="col-lg-8">

          <div className="dashboard-panel">

            <h5>
              Quick Actions
            </h5>

            <div className="action-grid">

              <button className="action-btn">
                Add Material
              </button>

              <button className="action-btn">
                Add Product
              </button>

              <button className="action-btn">
                Create GRN
              </button>

              <button className="action-btn">
                Create Production
              </button>

              <button className="action-btn">
                Create Dispatch
              </button>

            </div>

          </div>

        </div>

        <div className="col-lg-4">

          <div className="dashboard-panel">

            <h5>
              Inventory Alerts
            </h5>

            <ul className="alert-list">

              <li>
                No low stock items
              </li>

              <li>
                Inventory status healthy
              </li>

            </ul>

          </div>

        </div>

      </div>

    </MainLayout>

  );

};

export default Dashboard;